import styled from "styled-components";

export const InfoWrapper = styled.div`
    box-sizing: border-box;
    min-height: 100%;
    position: relative;
    padding-left: 10%;
    padding-right: 10%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/desktop/Info/Info.sc.js